import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { AuthProvider } from "./AuthContext";

const msalInstance = new PublicClientApplication(msalConfig);

async function startApp() {
    await msalInstance.initialize();

    ReactDOM.createRoot(document.getElementById("root")!).render(
        <MsalProvider instance={msalInstance}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </MsalProvider>
    );
}

startApp();